import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MobileLoginProxyConfirmation from './mobile-login-proxy-confirmation-model'
import {
  CreateMobileLoginProxyConfirmationAsync,
  DeleteMobileLoginProxyConfirmationAsync,
  LoadMobileLoginProxyConfirmationsAsync,
} from './mobileLoginProxyConfirmation-thunk'
const initialState: mobileLoginProxyConfirmationSliceState = {
  mobileLoginProxyConfirmation: [],
  selected_mobileLoginProxyConfirmation: '',
  is_loading_mobileLoginProxyConfirmation: false,
  is_creating_mobileLoginProxyConfirmation: false,
  is_deleting_mobileLoginProxyConfirmation: false,
}
export interface mobileLoginProxyConfirmationSliceState {
  mobileLoginProxyConfirmation: MobileLoginProxyConfirmation[]
  selected_mobileLoginProxyConfirmation?: string
  is_loading_mobileLoginProxyConfirmation: boolean
  is_creating_mobileLoginProxyConfirmation: boolean
  is_deleting_mobileLoginProxyConfirmation: boolean
}
export const mobileLoginProxyConfirmationSlice = createSlice({
  name: 'mobileLoginProxyConfirmation',
  initialState,
  reducers: {
    setSelectedmobileLoginProxyConfirmation: (state, action) => {
      state.selected_mobileLoginProxyConfirmation = action.payload
    },
    clearStatemobileLoginProxyConfirmation: (state) => {
      state.mobileLoginProxyConfirmation = []
      state.is_loading_mobileLoginProxyConfirmation = false
      state.is_creating_mobileLoginProxyConfirmation = false
      state.is_deleting_mobileLoginProxyConfirmation = false
    },
    mergemobileLoginProxyConfirmation: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mobileLoginProxyConfirmation = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mobileLoginProxyConfirmation = merge(
            state.mobileLoginProxyConfirmation,
            payload,
          ) as any
        }
      }
    },

    add_mobileLoginProxyConfirmation: (state, action) => {
      if (action.payload) {
        state.mobileLoginProxyConfirmation = [
          ...state.mobileLoginProxyConfirmation,
          action.payload,
        ]
      }
    },
    set_mobileLoginProxyConfirmation: (state, action) => {
      let { key, value, id } = action.payload
      state.mobileLoginProxyConfirmation =
        state.mobileLoginProxyConfirmation.map((item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMobileLoginProxyConfirmationsAsync.pending, (state) => {
      state.is_loading_mobileLoginProxyConfirmation = true
    })
    builder.addCase(
      LoadMobileLoginProxyConfirmationsAsync.fulfilled,
      (state, action) => {
        state.is_loading_mobileLoginProxyConfirmation = false
        if (action.payload) {
          state.mobileLoginProxyConfirmation = action.payload
        }
      },
    )
    builder.addCase(
      LoadMobileLoginProxyConfirmationsAsync.rejected,
      (state) => {
        state.is_loading_mobileLoginProxyConfirmation = false
      },
    )
    builder.addCase(
      CreateMobileLoginProxyConfirmationAsync.pending,
      (state) => {
        state.is_creating_mobileLoginProxyConfirmation = true
      },
    )
    builder.addCase(
      CreateMobileLoginProxyConfirmationAsync.fulfilled,
      (state) => {
        state.is_creating_mobileLoginProxyConfirmation = false
      },
    )
    builder.addCase(
      CreateMobileLoginProxyConfirmationAsync.rejected,
      (state) => {
        state.is_creating_mobileLoginProxyConfirmation = false
      },
    )
    builder.addCase(
      DeleteMobileLoginProxyConfirmationAsync.pending,
      (state) => {
        state.is_deleting_mobileLoginProxyConfirmation = true
      },
    )
    builder.addCase(
      DeleteMobileLoginProxyConfirmationAsync.fulfilled,
      (state, action) => {
        state.is_deleting_mobileLoginProxyConfirmation = false
        if (state.mobileLoginProxyConfirmation) {
          state.mobileLoginProxyConfirmation =
            state.mobileLoginProxyConfirmation.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteMobileLoginProxyConfirmationAsync.rejected,
      (state) => {
        state.is_deleting_mobileLoginProxyConfirmation = false
      },
    )
  },
})

export const {
  clearStatemobileLoginProxyConfirmation,
  setSelectedmobileLoginProxyConfirmation,
  set_mobileLoginProxyConfirmation,
  mergemobileLoginProxyConfirmation,
  add_mobileLoginProxyConfirmation,
} = mobileLoginProxyConfirmationSlice.actions

export const get_mobileLoginProxyConfirmation =
  (id?: string) =>
  (state: {
    mobileLoginProxyConfirmation: {
      mobileLoginProxyConfirmation: MobileLoginProxyConfirmation[]
    }
  }): MobileLoginProxyConfirmation | null => {
    let temp =
      state?.mobileLoginProxyConfirmation?.mobileLoginProxyConfirmation?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.mobileLoginProxyConfirmation?.mobileLoginProxyConfirmation[0] ||
      null
    )
  }
export const get_selected_mobileLoginProxyConfirmation = (state: {
  mobileLoginProxyConfirmation: mobileLoginProxyConfirmationSliceState
}): MobileLoginProxyConfirmation | null => {
  let id =
    state?.mobileLoginProxyConfirmation?.selected_mobileLoginProxyConfirmation
  let temp =
    state?.mobileLoginProxyConfirmation?.mobileLoginProxyConfirmation?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mobileLoginProxyConfirmation = (state: {
  mobileLoginProxyConfirmation: {
    mobileLoginProxyConfirmation: MobileLoginProxyConfirmation[]
  }
}): MobileLoginProxyConfirmation[] => {
  let temp = state?.mobileLoginProxyConfirmation?.mobileLoginProxyConfirmation
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mobileLoginProxyConfirmation_busy = (state: {
  mobileLoginProxyConfirmation: mobileLoginProxyConfirmationSliceState
}) => {
  return (
    state?.mobileLoginProxyConfirmation
      .is_deleting_mobileLoginProxyConfirmation ||
    state?.mobileLoginProxyConfirmation
      .is_loading_mobileLoginProxyConfirmation ||
    state?.mobileLoginProxyConfirmation.is_creating_mobileLoginProxyConfirmation
  )
}
export const is_deleting_mobileLoginProxyConfirmation_busy = (state: {
  mobileLoginProxyConfirmation: mobileLoginProxyConfirmationSliceState
}) => {
  return state?.mobileLoginProxyConfirmation
    .is_deleting_mobileLoginProxyConfirmation
}
export const is_loading_mobileLoginProxyConfirmation_busy = (state: {
  mobileLoginProxyConfirmation: mobileLoginProxyConfirmationSliceState
}) => {
  return state?.mobileLoginProxyConfirmation
    .is_loading_mobileLoginProxyConfirmation
}
export const is_creating_mobileLoginProxyConfirmation_busy = (state: {
  mobileLoginProxyConfirmation: mobileLoginProxyConfirmationSliceState
}) => {
  return state?.mobileLoginProxyConfirmation
    .is_creating_mobileLoginProxyConfirmation
}

export default mobileLoginProxyConfirmationSlice.reducer
